function wdSwapProductImage(card, mediaId, clearMedia) {
  if (!mediaId && !clearMedia) return;

  var imageWrapper = card.querySelector('.product-item__aspect-ratio');
  if (!imageWrapper) return;

  imageWrapper.querySelectorAll('.product-item__primary-image').forEach(function (img) {
    img.hidden = clearMedia || img.dataset.mediaId != mediaId;
  });
}

function wdSyncThumbActive(card, activeThumb) {
  card.querySelectorAll('.wd-variant-thumb').forEach(function (t) {
    t.classList.toggle('wd-variant-thumb--active', t === activeThumb);
  });
}

function wdSwapSecondaryImage(card, mediaId, clearMedia) {
  if (!mediaId && !clearMedia) return;

  card.querySelectorAll('.product-item__secondary-image[data-secondary-for]').forEach(function (img) {
    img.hidden = clearMedia || img.dataset.secondaryFor != mediaId;
  });
}

function wdSyncSoldOutLabel(card, thumb) {
  if (!thumb || !thumb.hasAttribute('data-product-available')) return;

  var available = thumb.dataset.productAvailable === 'true';
  var soldOutText = (card.dataset.wdSoldOutText || '').trim();

  card.classList.toggle('product-item--sold-out', !available);

  card.querySelectorAll('[data-wd-sold-out-label], .product-item__label-list .label, .wd-card-tag').forEach(function(label) {
    if (label.hasAttribute('data-wd-sold-out-label') || (soldOutText && label.textContent.trim() === soldOutText)) {
      label.hidden = available;
      label.style.display = available ? 'none' : '';
    }
  });

  card.querySelectorAll('.product-item__label-list, .wd-card-tags').forEach(function(list) {
    var hasVisible = Array.prototype.some.call(list.children, function(c) { return !c.hidden; });
    list.hidden = !hasVisible;
    list.style.display = hasVisible ? '' : 'none';
  });
}

function wdBuildVariantUrl(baseUrl, variantId) {
  if (!baseUrl) return '';

  var url = new URL(baseUrl, window.location.origin);

  if (variantId) {
    url.searchParams.set('variant', variantId);
  }

  return url.pathname + url.search + url.hash;
}

function wdUpdateCardProductUrl(card, url) {
  if (!url) return;

  card.querySelectorAll([
    '.product-item__aspect-ratio',
    '.product-item-meta__title',
    '.product-item-meta__reviews-badge'
  ].join(',')).forEach(function (el) {
    el.setAttribute('href', url);
  });

  card.querySelectorAll('[aria-controls]').forEach(function (trigger) {
    var quickBuy = document.getElementById(trigger.getAttribute('aria-controls'));

    if (quickBuy && (quickBuy.matches('quick-buy-popover') || quickBuy.matches('quick-buy-drawer'))) {
      if (quickBuy.getAttribute('href') !== url) {
        quickBuy.innerHTML = '';
      }

      quickBuy.setAttribute('href', url);
    }
  });
}

function wdSyncQuickAddVariant(card, thumb) {
  if (!thumb || !thumb.dataset.variantId) return;

  card.querySelectorAll('form.product-item__quick-form input[name="id"], .product-item__cta-wrapper form input[name="id"]').forEach(function (input) {
    input.value = thumb.dataset.variantId;
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-item').forEach(function (card) {
    var activeThumb = card.querySelector('.wd-variant-thumb--active');
    if (!activeThumb) return;
    wdSwapProductImage(card, activeThumb.dataset.mediaId, activeThumb.dataset.clearMedia === 'true');
    wdSwapSecondaryImage(card, activeThumb.dataset.mediaId, activeThumb.dataset.clearMedia === 'true');
    wdSyncSoldOutLabel(card, activeThumb);
    wdSyncQuickAddVariant(card, activeThumb);
  });
});

// Variant thumb click
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.wd-variant-thumb');
  if (!thumb) return;

  var card = thumb.closest('product-item');
  if (!card) return;

  var mediaId = thumb.dataset.mediaId;
  var clearMedia = thumb.dataset.clearMedia === 'true';
  wdSwapProductImage(card, mediaId, clearMedia);
  wdSyncThumbActive(card, thumb);
  wdSwapSecondaryImage(card, mediaId, clearMedia);
  wdSyncSoldOutLabel(card, thumb);
  wdSyncQuickAddVariant(card, thumb);

  var productLink = card.querySelector('.product-item__aspect-ratio');
  var selectedUrl = thumb.dataset.siblingUrl || wdBuildVariantUrl(productLink && productLink.getAttribute('href'), thumb.dataset.variantId);
  wdUpdateCardProductUrl(card, selectedUrl);
});

// Color swatch radio change (e.g. mobile swatch dots)
document.addEventListener('change', function (e) {
  var radio = e.target.closest('.color-swatch__radio');
  if (!radio) return;

  var card = radio.closest('product-item');
  if (!card) return;

  var mediaId = radio.dataset.variantFeaturedMedia;
  if (!mediaId) return;

  wdSwapProductImage(card, mediaId);
  wdSyncThumbActive(card, card.querySelector('.wd-variant-thumb[data-media-id="' + mediaId + '"]'));
  wdSwapSecondaryImage(card, mediaId);
  wdSyncQuickAddVariant(card, radio);
});
